import { useEffect, useMemo } from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

function stripTrailingSlash(url) {
  return url.endsWith('/') ? url.slice(0, -1) : url
}

export default function TrackingHead() {
  const location = useLocation()

  const siteUrlRaw = import.meta.env.VITE_SITE_URL
  const googleSiteVerification = import.meta.env.VITE_GOOGLE_SITE_VERIFICATION || 'lB0-_zn0egNBQEsuWEQctj8xeWdetmUi0uVY4C_9GR0'
  const gaId = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-9K7VJ97RZE'
  const adsenseClient = import.meta.env.VITE_ADSENSE_CLIENT
  const clarityProjectId = import.meta.env.VITE_CLARITY_PROJECT_ID

  const canonicalUrl = useMemo(() => {
    if (!siteUrlRaw) return null
    // Ensure we standardize on non-www
    let base = stripTrailingSlash(String(siteUrlRaw))
    if (base.includes('://www.')) {
      base = base.replace('://www.', '://')
    }
    const path = `${location.pathname}${location.search || ''}`
    return `${base}${path}`
  }, [siteUrlRaw, location.pathname, location.search])

  // SPA pageview tracking (GA4)
  useEffect(() => {
    if (!gaId) return
    if (typeof window === 'undefined') return
    if (typeof window.gtag !== 'function') return

    window.gtag('config', gaId, {
      page_path: `${location.pathname}${location.search || ''}`,
      page_title: document?.title || undefined,
    })
  }, [gaId, location.pathname, location.search])

  return (
    <Helmet>
      {googleSiteVerification ? (
        <meta name="google-site-verification" content={googleSiteVerification} />
      ) : null}

      {canonicalUrl ? <link rel="canonical" href={canonicalUrl} /> : null}

      {gaId ? (
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`} />
      ) : null}
      {gaId ? (
        <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          window.gtag = gtag;
          gtag('js', new Date());
          // 首次 config 不自动发 pageview，后续由 SPA 路由变化触发
          gtag('config', '${gaId}', { send_page_view: false });
        `}</script>
      ) : null}

      {adsenseClient ? (
        <script
          async
          src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adsenseClient}`}
          crossOrigin="anonymous"
        />
      ) : null}

      {clarityProjectId ? (
        <script>{`
          (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "${clarityProjectId}");
        `}</script>
      ) : null}
    </Helmet>
  )
}





